<template>
  <div
    v-if="variants.v1 === variant"
    v-show="!isAnythingOnTopVisible"
    class="pxp-banner tw-fixed tw-z-[999] tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-px-4 tw-transition-all tw-duration-500 tw-ease-in-out"
    :style="`background-color: var(--${vars.backgroundColor}); top: ${headerHeight}px !important`"
  >
    <p class="tw-text-xs md:tw-text-base" style="color: var(--white)">
      {{ vars.bannerText }}
    </p>
    <nuxt-link
      :external="true"
      :to="vars.bannerButtonUrl"
      class="pxp-search-properties-btn tw-ml-8 lg:tw-block"
      :style="`background-color: var(--${vars.buttonBackgroundColor})`"
    >
      {{ vars.buttonText }}
    </nuxt-link>
  </div>
  <div
    v-else-if="variants.v2 === variant"
    v-show="!isAnythingOnTopVisible"
    class="banner-v-2 pxp-banner tw-fixed tw-z-[999] tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-pl-4 tw-transition-all tw-duration-500 tw-ease-in-out md:tw-px-4 md:tw-py-7"
    :style="`background-image: url(${vars.backgroundImage}); top: ${headerHeight}px !important`"
  >
    <p class="tw-text-xs md:tw-text-base" style="color: var(--white)">
      {{ vars.bannerText }}
    </p>
    <div class="tw-ml-8">
      <nc-button :link="vars.bannerButtonUrl" :is-link="true" :label="vars.buttonText" :height="45"> </nc-button>
    </div>
  </div>
  <div
    v-else-if="variants.v3 === variant"
    v-show="!isAnythingOnTopVisible"
    class="banner-v-2 pxp-banner tw-fixed tw-z-[999] tw-flex tw-h-20 tw-w-full tw-items-center tw-justify-center tw-py-8 tw-pl-4 tw-transition-all tw-duration-500 tw-ease-in-out md:tw-px-4 md:tw-py-7 lg:tw-h-14"
    :style="`background-color: var(${vars.backgroundColor}); top: ${headerHeight}px !important`"
  >
    <div class="tw-flex tw-w-full tw-items-center tw-justify-center lg:tw-flex-[65%]">
      <p style="color: #fff !important">
        {{ vars.bannerText }}
      </p>
      <div class="tw-ml-8">
        <nuxt-link
          style="padding: 10px 20px !important"
          :to="vars.buttonLinkUrl"
          :class="`n-${vars.buttonTypeText} tw-h-full`"
          >{{ vars.buttonLabelText }}</nuxt-link
        >
      </div>
    </div>
    <div class="tw-hidden tw-gap-3 lg:tw-flex lg:tw-flex-[35%]">
      <p v-for="number in numbers" class="tw-whitespace-nowrap" style="color: #fff !important" :key="number.phone">
        {{ number.title }}:
        <nuxt-link class="n-link" style="font-weight: 300 !important" :to="`tel:${number.phone}`">{{
          number.phone
        }}</nuxt-link>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import NcButton from '~/components/common/inputs/NcButton.vue';
import { RepoStates } from '~/units/core/types';
import { mapState } from 'pinia';
import { useCoreStore } from '~/units/core/store';

export default defineNuxtComponent({
  name: 'Banner',
  components: { NcButton },

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'BackgroundImageV2',
        v3: 'v3',
      },
    };
  },

  computed: {
    ...mapState(useCoreStore, ['headerHeight', 'isAnythingOnTopVisible']),

    numbers() {
      return this.groupedVariables.numbers;
    },
  },

  mixins: [ComponentMixin],
});
</script>

<style scoped>
.pxp-banner.pxp-is-sticky.banner-v-2 {
  top: 108px !important;
}
</style>
